import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import {
  SettingsFavoritesActionCreators,
  favoritesLoadingStateSelector,
  favoritesSelector,
} from '../../../redux/ui/settingsFavorites';
import { parseNumber } from '../../../utils/parseNumber';
import { CompressPageSetting } from './CompressPageSetting';
import { Favorite } from './Favorite';
import { InitRequest } from './InitRequest';
import { ShortenedHashPageSetting } from './ShortenedHashPageSetting';

export const QueryStringHandler = () => {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const favId = searchParams.get('fav_id');
  const q = searchParams.get('q');
  const s = searchParams.get('s');

  const settingsFavorite = useSelector(favoritesSelector, shallowEqual);
  const favoritesLoadingState = useSelector(
    favoritesLoadingStateSelector,
    shallowEqual
  );

  useEffect(() => {
    if (favoritesLoadingState === 'prepare') {
      dispatch(SettingsFavoritesActionCreators.fetchSettingsFavoritesAction());
    }
  }, [dispatch, favoritesLoadingState]);

  if (
    (favId != null && q != null) ||
    (favId != null && s != null) ||
    (q != null && s != null)
  ) {
    throw new Error('クエリ文字列のfavIdとqとsは同時に指定できません');
  }

  // お気に入りでページを表示させる
  if (favId != null) {
    return (
      <Favorite
        favId={parseNumber(favId)}
        settingsFavorite={settingsFavorite}
      />
    );
  }

  // 検索条件を引き継いで別画面を表示させる
  if (q != null) {
    return <CompressPageSetting q={q} />;
  }

  // 検索結果共有でページを表示させる
  if (s != null) {
    return <ShortenedHashPageSetting s={s} />;
  }

  return <InitRequest />;
};
